import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { ProjectCardTemplate as template } from './project-card.template';
import { ProjectCardStyles as styles } from './project-card.styles';
import { IAllProjects } from '../../../types';
import { IProjectModalService } from '../../../services';
import { logger } from '@genesislcap/foundation-comms';
import { IUserService } from '../../../services/user.service';

const name = 'project-card';

@customElement({
  name,
  template,
  styles,
})
export class ProjectCard extends FASTElement {
  @IProjectModalService projectModalService: IProjectModalService;
  @IUserService userService!: IUserService;

  @attr @observable isSelected: boolean;
  @attr @observable project: IAllProjects;
  @attr @observable isDraftProject: boolean = false;

  public resumeDraftProject() {
    this.$emit('draftProjectSelected', this.project);
  }

  public deleteDraftProject() {
    this.projectModalService.eventDraftProjectDelete(this.project).then((response) => {
      if (response && response.MESSAGE_TYPE === 'EVENT_ACK') {
        logger.log('Draft project deleted successfully!');
      } else {
        logger.error(response.ERROR);
      }
    });
  }
}
